var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { inject } from 'mobx-react';
import { Footer } from '@shared-ui/global-navigation-footer';
export var SharedUIFooter = inject('analytics')(function (props) {
    var analytics = props.analytics, otherProps = __rest(props, ["analytics"]);
    var analyticsCallback = function (rfrrId, linkName) { return (analytics === null || analytics === void 0 ? void 0 : analytics.trackEvent(rfrrId, linkName, analytics.omnitureData, null, true)); };
    return React.createElement(Footer, __assign({ analyticsCallback: analyticsCallback }, otherProps));
});
//# sourceMappingURL=shared-ui-footer.js.map